import { FC } from "react";
import { IHistoryChange } from "toolkit/organizations/types";
import { Link } from "react-router-dom";
import { convertDate } from "helpers";
import cn from "classnames";
import styles from "./HistoryChanges.module.sass";

const titleCategorized = {
  NOT_CATEGORIZED: "Категорирование не проводилось",
  PRIMARY_STARTED: "Первичное категорирование начато",
  PRIMARY_DONE: "Первичное категорирование завершено",
  SECONDARY_STARTED: "Последующее (повторное) категорирование начато",
  SECONDARY_DONE: "Последующее (повторное) категорирование завершено",
};

interface RowProps {
  row: IHistoryChange;
}

const Row: FC<RowProps> = ({ row }) => {
  return (
    <div className={styles.tableRow}>
      <div className={styles.tableBodyTd}>{titleCategorized[row.status]}</div>
      <Link
        className={cn(styles.tableBodyTd, "link")}
        to={`/user/${row.responsible.id}`}
      >
        {row.responsible.fullName}
      </Link>
      <div className={styles.tableBodyTd}>{convertDate(row.timestamp)}</div>
    </div>
  );
};

export default Row;
